import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import * as contentActions from "../content/content.actions";
import { getNewsContent } from "../content/content.selectors";

import { PageHeader, ContentSection } from "./components";
import Article from "../content/components/Article";
import FeaturedContentList from "../content/components/FeaturedContentList";
import ContentList from "../content/components/ContentList";
import { Localize } from "../../locale/localization";

class NewsPage extends Component {
  componentWillMount = () => {
    const { getContents } = this.props;
    getContents();
  };

  render() {
    const { content, singleContent } = this.props;
    const featuredItems = content.slice(0, 4);
    const olderItems = content.slice(4, 8);
    return (
      <div>
        <PageHeader title={Localize("news.header")} />
        {singleContent ? (
          <ContentSection>
            <Article
              imageUrl={singleContent.imageUrl}
              videoUrl={singleContent.videoUrl}
              title={singleContent.name}
              category={singleContent.category}
              content={singleContent.content}
              link={singleContent.link}
              tags={singleContent.tags}
            />
          </ContentSection>
        ) : (
          <ContentSection>
            <FeaturedContentList items={featuredItems} type="news" />
            {olderItems &&
              olderItems.length > 0 && (
                <ContentList
                  title={Localize("news.prev")}
                  items={olderItems}
                  type="news"
                  widths={["20%", "40%", "40%"]}
                />
              )}
          </ContentSection>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, { match }) => {
  const content = getNewsContent(state);
  const { id } = match.params;
  const singleContent = id ? state.entities.content.byId[id] : null;
  return {
    content,
    singleContent
  };
};

const ConnectedNewsPage = connect(mapStateToProps, Object.assign({}, contentActions))(NewsPage);

export default withRouter(ConnectedNewsPage);



// WEBPACK FOOTER //
// ./src/modules/pages/NewsPage.js